import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { MenuController } from '@ionic/angular';
import { AlertService } from '../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Capacitor } from '@capacitor/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss', '../authentication.scss']
})
export class LoginPage {

  title = 'Login';
  loginForm: FormGroup;
  phoneNumber: string = '';

  appVersion: string = "3.0";
  buildVersion: string = "1";
  displayEnv: boolean = false;

  constructor(
    private router: Router,
    private menuCtrl: MenuController,
    private docTitle: Title,
    private formBuilder: FormBuilder,
    public alertService: AlertService,
    private amplifyAppService: AuthService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private analyticsService: AnalyticsService,
  ) {
    this.menuCtrl.enable(false, 'left');
    this.menuCtrl.enable(false, 'right');
    this.docTitle.setTitle(this.title);
    this.loginForm = this.formBuilder.group({
      phone: ['', [Validators.required]],
    });
    this.analyticsService.tagRoute('unauthenticated/login');
  }

  ionViewDidEnter() {
    this.loginForm.updateValueAndValidity();
  }

  verifyLogin() {
    this.analyticsService.tagButtonPress('login_page', 'verifylogin');
    const intlNumber = this.phoneNumber;
    if (Capacitor.isNativePlatform() && this.isDemoUser()) {
      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: intlNumber }});
    } else if (intlNumber) {
      this.sendCode(intlNumber);
    }
  }

  goToContactUs() {
    this.analyticsService.tagButtonPress('login_page', 'contactus');
    this.router.navigate(['unauthenticated', 'contactus']);
  }

  async sendCode(phoneNumber: string) {
    try {
      if (Capacitor.isNativePlatform()) {
        await this.amplifyAppService.sendForgotPasswordCode(phoneNumber);
      } else {
        this.amplifyAppService.sendCustomAuthSmsCode(phoneNumber);
      }
      this.router.navigate(['unauthenticated', 'verifylogin'], { queryParams: { phone: phoneNumber }});
    } catch (error) {
      this.handleError(error);
    }
  }

  handleError(error: any) {
    console.error('Login: Code', error);
    if (this.amplifyAppService.isInvalidParameterException(error)) {
      this.sendSignUpCode(this.phoneNumber);
    } else if (this.amplifyAppService.isUserNotFoundException(error)) {
      this.handleUserNotFoundAlert();
    } else {
      this.alertService.showAmplifyAuthError(error);
    }
  }

  handleUserNotFoundAlert() {
    this.alertService.confirm(
      `This mobile number is not registered`,
      `Would you like to register?`,
      `Register`,
      () => { this.goToRegister(); });
  }

  sendSignUpCode(phone: string) {
    this.amplifyAppService.resendSignUpCode(phone)
      .then(() => {
        this.toastService.show(`We sent a SMS to ${phone} with a code, please enter it here.`);
        this.router.navigate(['../VerifySignUpPage'], { queryParams: { phone: phone }, relativeTo: this.activatedRoute });
      })
      .catch((error: any) => {
        this.alertService.showAmplifyAuthError(error);
        console.error('sendSignUpCode:', error);
      });
  }

  goToRegister() {
    this.router.navigate(['unauthenticated', 'siteCodeEntry']);
  }

  isDemoUser() {
    return (this.phoneNumber ?? '').endsWith('000000');
  }
}
